import enLocale from 'element-ui/lib/locale/lang/zh-CN'
const zh = {
  heardNavigation: {
    home: '首页',
    developmentType: '开发类型',
    productDisplay: '产品展示',
    about: '关于团队',
    contact: '联系我们',
    changeLang: 'CH/EN'
  },
  footer: {
    aboutUs: {
      title: '关于我们',
      tip1: '我们的团队',
      tip2: '联系我们'
    },
    devType: {
      title: '开发类型',
      tip1: 'Android开发',
      tip2: 'IOS开发',
      tip3: '蓝牙类产品开发',
      tip4: 'WIFI类产品开发',
      tip5: '小程序开发'
    },
    case: {
      title: '经典案例',
      tip1: '智能带屏音箱',
      tip2: '智能车载充电器',
      tip3: '智能云相框'
    }
  },
  home: {
    bannerText: {
      tip1: {
        h1: '蓝牙类产品开发',
        h4: 'Anker Roav F2',
        h42: 'BLE/音频'
      },
      tip2: {
        h1: 'AI带屏音箱产品开发',
        h4: '晓言智能音箱',
        h42: 'AI/4G'
      },
      tip3: {
        h1: 'WiFi音箱产品开发',
        h4: 'Dyaudio Music 系列',
        h42: 'WiFi'
      }
    },
    intro: {
      h: '云耳是一家服务于硬件的配套软件开发商',
      p: '融合互联网思维，实现智能设备无线对接',
      button: '了解更多'
    },
    devType: {
      tip1: {
        title: 'iOS/Android App开发',
        subtitle: '手机移动端应用程序',
        content: '智能手机上的软件开发，丰富的iOS/Android双端开发经验。'
      },
      tip2: {
        title: 'Android设备端开发',
        subtitle: '定制化Android系统级应用',
        content: '为运行Android系统的智能硬件提供软件方案，为客户提供定制化功能。'
      },
      tip3: {
        title: '后台应用开发',
        subtitle: '云端服务器',
        content: '与软件配套的后台服务器功能开发，为软件提供更强力的后背力量。'
      },
      tip4: {
        title: '蓝牙类产品开发',
        subtitle: '蓝牙产品配套软件',
        content: '为蓝牙设备提供软件配套服务，定制化需求。'
      },
      tip5: {
        title: 'Wi-Fi类产品开发',
        subtitle: '无线产品配套软件',
        content: '成熟的Wifi类产品开发，音箱、相框等多场景软件方案'
      },
      tip6: {
        title: '小程序开发',
        subtitle: '热门微信小程序',
        content: '微信小程序开发，助力产品更近一步'
      }
    },
    productCase: {
      title: '产品案例',
      tip1: {
        title: '物联网带屏音箱',
        subtitle: 'Ai语音'
      },
      tip2: {
        title: '学生教育平板',
        subtitle: '教辅工具'
      },
      tip3: {
        title: 'WiFi音箱',
        subtitle: '立体声配对'
      },
      tip4: {
        title: '智能云相框',
        subtitle: '即时传图'
      },
      tip5: {
        title: '蓝牙播控音箱',
        subtitle: '智能操控'
      },
      tip6: {
        title: '智能车载充电器',
        subtitle: '寻车定位'
      },
      tip7: {
        title: 'HIFI音箱+AI电台',
        subtitle: 'HIFI播放AI电台'
      },
      tip8: {
        title: '旅行翻译机',
        subtitle: '突破语言障碍'
      }
    },
    clients: {
      tip1: {
        name: '客户名'
      },
      tip2: {
        name: '客户名'
      },
      tip3: {
        name: '客户名'
      },
      tip4: {
        name: '客户名'
      },
      tip5: {
        name: '客户名'
      }
    }
  },
  product: {
    part1: {
      tip1: '关于客户',
      tip2: '我们在项目中使用的技能/项目概述',
      tip3: '项目详情'
    },
    xiaoyan: {
      title: '物联网带屏音箱',
      text: '简介',
      aboutClient: {
        h: '',
        p: '中移物联网有限公司是中国移动通信集团公司出资成立的全资子公司，公司按照市场化机制独立运作，专业运营物联网专用网络，研发、设计、生产物联网专用芯片、模组和终端，开发宜居通、车联网、二维码等特色产品，打造物联网开放平台，推广物联网解决方案，致力于推动物联网在各行业的规模应用。',
        link: 'http://iot.10086.cn/'
      },
      skill: '•智能语音操控 <br>' +
        '•多种方式高清音视频通话（4G/网络/和家固话）<br>' +
        '•接入海量音视频声源娱乐资源（咪咕音乐/咪咕视频/咪咕听书）<br>' +
        '•家庭相册，向家人分享图片和视频<br>' +
        '•智能闹钟/备忘录/新闻天气等生活技能',
      details: '近年来，智能音箱概念持续火爆、市场反馈良好。为推广物联网解决方案，致力于推动物联网在各行业的规模应用，晓言智能带屏音箱应运而生。<br>' +
        '<br>' +
        '晓言智能带屏音箱主要功能为智能AI唤醒控制，高清音视频通话，支持Wi-Fi+4G，满足全场景使用需求；搭载科大讯飞AI平台，语义技能定制，接入海量音视频资源，满足用户需求。'
    },
    pad: {
      title: '学生教育平板',
      text: '简介',
      aboutClient: {
        h: '',
        p: '',
        link: ''
      },
      skill: '',
      details: '教育信息化时代的到来，传统化授课已无法满足教学需求，平板电脑已作为教学设施走进校园。此次项目是根据职教学校特殊性开发的一款教育平板，学生可以通过平板内的应用市场下载相关课件内容，应用内提供丰富的文字、图片、视频等多媒体内容，并可以通过消息推送方便师生互动。'
    },
    dynaudio: {
      title: 'WiFi 音箱',
      text: '简介',
      aboutClient: {
        h: '',
        p: '丹拿音响Dynaudio Music——一个享誉盛名、来自丹麦的顶级扬声器品牌。自1977年成立以来，秉持“纯粹原音，如临现场 ”的理念，丹拿音响对原音重现孜孜不倦的追求和极大的热情从未停止过',
        link: ''
      },
      skill: '•立体声配对编组<br>' +
        '•WiFi配网<br>' +
        '•支持音乐流服务，可以从各大知名互联网电台播放音源<br>' +
        '•通过 DLNA、Apple AirPlay、以及蓝牙连接的方式在 Music 系列产品中播放',
      details: '专为丹拿智能无线产品研发设的配套APP，包括设置多房间系统、欣赏喜爱的音乐等资源管理办法，可以将高品质音乐，通过 DLNA、Apple AirPlay、以及蓝牙连接的方式在 Music 系列产品中播放，同时也可以通过Audio In、数字光纤、以及 HDMI 等有线连接放的方式来播放喜欢的音乐。'
    },
    Polaroid: {
      title: '智能云相册',
      text: '简介',
      aboutClient: {
        h: '',
        p: '',
        link: ''
      },
      skill: '产品亮点：<br>' +
        '<br>' +
        '•照片管理（裁剪、旋转、设置轮播形式）<br>' +
        '•微信小程序/邮箱传图<br>' +
        '•手机APP传图、音乐、视频<br>' +
        '•U盘、SD卡内容显示管理（此案件、旋转、设置轮播形式、移动至本地存储）<br>' +
        '•天气预报/日历/闹钟<br>' +
        '•人体感应休眠',
      details: '传统相框展示照片固定且更换麻烦，时间长了后还容易对照片造成无法修复的损坏。为解决这一痛点，智能云相框应运而生。通过手机APP可以随时随地将照片上传至相框，然后选择照片进行轮播展示，想随时更换更新相册都可以，另外还支持推送音视频文件，丰富用户体验。'
    },
    hycat: {
      title: '蓝牙播控音箱',
      text: '简介',
      aboutClient: {
        h: '',
        p: '黄油猫CAT工作室，坐落上海，主打飞船加湿器、蓝牙音箱、充电宝等文创产品，曾合作过BILIBILI、超电文化、网易、腾讯、京东等多个大企业的OEM和ODM项目',
        link: 'http://www.hymcat.com/'
      },
      skill: '•灯光控制<br>' +
        '•快速更换设备语音包<br>' +
        '•语音包激活码兑换<br>' +
        '•录音传送',
      details: '山灵播控是配合山灵家音响产品研发的专业播控软件，在传统蓝牙播控基础上，可以通过APP控制音响设备蓝牙编码选择、增益设置、EQ调试、滤波器设置、声道调试等，另外还可解析CUE音乐、文件夹跳曲及设备TF卡歌曲的显示与播控等功能，不同音响设备连接后展示不同功能交互页面，让用户更为直观地操控。'
    },
    anker: {
      title: '智能车载充电器',
      text: '简介',
      aboutClient: {
        h: '',
        p: 'Anker属于安克创新科技股份有限公司旗下品牌。Anker曾连续三年进入BrandZ™“中国出海品牌50强”榜前十强，获得过亚马逊全球颁发的“杰出中国制造奖”，24次获得德国红点设计奖、iF设计奖等工业设计大奖。<br>' +
          '<br>' +
          '主营产品涵盖移动电源、充电器、数据线、蓝牙外设等智能数码周边，重点市场覆盖北美、日本、欧洲、中国等100多个国家和地区。目前，Anker全球用户已超过5000万人。 \n' +
          '<br>' +
          '<br>' +
          '<br>' +
          '合作产品：\tRoav SmartCharge F3/Roav SmartCharge F2/Roav SmartCharge F0',
        link: 'https://www.anker-in.com'
      },
      skill: '1、账号注册登录-方便收集用户信息，建立企业用户体系，来进行用户分析，为企业带来更多的价值；' +
        '<br>' +
        '2、智能寻车-实现设备无需内置GPS芯片即可实现寻车定位功能，方便车主查找自己的爱车；' +
        '<br>' +
        '3、FM调频-车机无FM也可实现FM调频，并支持收藏喜欢的频道；' +
        '<br>' +
        '4、电压监测-监测车内电压情况，助力爱车安全，出行无忧' +
        '<br>' +
        '5、设备车灯调节-同步控制设备灯光，灯随你动；' +
        '<br>' +
        '6、智能监测U盘，方便用户播放歌曲选择蓝牙通道还是U盘通道。',
      details: '极速连接，实现一应用多连，不同型号产品在同一个APP中连接成功后展现不同个功能交互页面，减少了用户下载多个APP的尴尬。在原基础车充功能下，配合APP增加车载FM调频、智能寻车、电压检测、灯光调试等增值功能，丰富了用户体验，增加车主使用产品的实用性。'
    },
    shanling: {
      title: 'HiFi音箱+AI电台',
      text: '简介',
      aboutClient: {
        h: '',
        p: '山灵音响为深圳山灵数码科技发展有限公司的国产高端HIFI音响品牌，是集音响设备研发、生产、加工、销售于一体的高新技术合资企业。拥有便携播放器、便携耳放、便携解码耳放、HiFi耳机、SACD/CD机、便携无损播放器及便携音箱等多品类产品，在业界中享有良好的声誉。',
        link: 'https://www.shanling.com'
      },
      skill: '•多设备蓝牙对接兼容<br>' +
        '•CUE 歌曲解析，专业歌曲信息解析显示<br>' +
        '•文件夹跳曲<br>' +
        '•EQ调试<br>' +
        '•设备TF 卡歌曲的显示与播控<br>' +
        '•歌曲滤波器、声道、增益、编码选择的调试',
      details: '山灵播控是配合山灵家音响产品研发的专业播控软件，在传统蓝牙播控基础上，可以通过APP控制音响设备蓝牙编码选择、增益设置、EQ调试、滤波器设置、声道调试等，另外还可解析CUE音乐、文件夹跳曲及设备TF卡歌曲的显示与播控等功能，不同音响设备连接后展示不同功能交互页面，让用户更为直观地操控。'
    },
    translator: {
      title: '旅行翻译机',
      text: '简介',
      aboutClient: {
        h: '',
        p: 'hii 是一个来自北美的品牌，转为跨境旅游、语言学习、商务翻译而生的品牌，专业团队历时三年研发语音辨识与即时翻译领先技术，让30种不同语音沟通无障碍，实现以人为本，用科技创新生活的全新理念，以高科技人性化的设计成就卓越不凡的智能翻译产品，享受不同语言沟通乐趣。',
        link: ''
      },
      skill: 'hii 翻译机提供22国语言互译，出国无忧，让不同语言间的沟通不再困难。',
      details: '基于深度算法，实现22国语言即时互译，满足用出行不同国家在衣食住行等领域沟通无忧。'
    }
  },
  about: {
    part1: {
      title: '关于团队',
      text: '深圳云耳科技有限公司成立于2015年，致力于专业的蓝牙类产品、WiFi类产品、安卓设备端产品、APP的软件开发，是领先的物联网开发服务商和移动互联网解决方案提供商，已与多家知名企业建立了合作关系，经典案例遍及各行各业。我们是一支集视觉设计、用户体验设计、交互设计、技术研发于一体的专业互联网团队，团队成员具有多年移动互联网从业经验，于物联网快速发展的时代，期待能够帮助更多的客户搭上物联网的快车，通过创新精神及专业服务为客户营造优质的客户体验，实现共赢。',
      tip1: 'Android开发工程师 50%',
      tip2: 'iOS开发工程师 30%',
      tip3: '软件测试工程师 10%',
      tip4: 'UI设计师 10%'
    },
    part2: {
      title: '企业文化'
    }
  },
  ...enLocale
}
export default zh



// WEBPACK FOOTER //
// ./src/i18n/langs/zh.js